import * as React from "react"
import { Jumbo } from "../components/jumbo"
import { BasePageProps } from "../components/page_renderer"

export interface NewsletterSignupPageProps extends BasePageProps {
  kind: "newsletterSignup"
  pageTitle: string
  headerTitle: string
  description: string
  imageUrl: string
  imageUrlLarge: string
  phImageUrlSmall?: string
  phImageUrl: string
  phImageUrlLarge: string
  imageAlt: string
}

export class NewsletterSignupPage extends React.Component<NewsletterSignupPageProps, {}> {
  componentDidMount() {
    document.title = this.props.pageTitle
  }

  render() {
    const p = this.props

    return (
      <>
        <Jumbo
          title={p.headerTitle}
          contents={p.description}
          imageUrl={p.phImageUrl}
          imageUrlLarge={p.phImageUrlLarge}
          imageAlt={p.imageAlt}
          size="small"
        />

        <div className="container--mg align--center">
          <div className="newsletter">
            <div className="newsletter__container container--s align--center">
              <iframe
                width={960}
                height={830}
                src={"https://app.hellodialog.com/subscribe/91a3cdb6a94b8ce97f50c20d"}
                title="Aanmeldformulier voor nieuwsbrief"
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

{/* TH: Added to styleguide! */}
